<script setup>
import { computed } from 'vue';

const $props = defineProps({
    buttonLabel: {
        type: String,
        default: 'Browse all jobs'
    },
    buttonLink: {
        type: Object,
        required: true
    },
    buttonColor: {
        type: String,
        default: 'secondary'
    },
    buttonSize: {
        type: String,
        default: 'lg'
    },
    buttonPadding: {
        type: String,
        default: 'sm xl'
    }
});

const buttonOptions = computed(() => ({
    to: $props.buttonLink,
    color: $props.buttonColor,
    label: $props.buttonLabel,
    padding: $props.buttonPadding,
    size: $props.buttonSize
}));
</script>

<template>
    <div class="call-to-action-banner container-md q-px-md q-py-xl bg-default text-white text-center shadow-10 rounded-borders-md">
        <h3 class="text-h2 q-mt-md">
            <slot name="heading">Looking for More Opportunities?</slot>
        </h3>
        <p class="text-h5 text-font-body q-mb-lg">
            <slot name="subheading">Explore more jobs with upfront salary details that respect your worth.</slot>
        </p>
        <div class="flex justify-center q-pt-md">
            <q-btn v-bind="buttonOptions"/>
        </div>
    </div>
</template>
